/**
 * This object must be kept in sync manually with the CUSTOMER_PORTAL_APP_FEATURE_FLAG
 * defined in the server CustomerPortalAppFeatureFlag file
 * (server/app/src/constants/CustomerPortalAppFeatureFlag.ts), as well as any other
 * properties added to BrandConfig's featureFlags list.
 */
export const FeatureFlag = {
	PUSH_NOTIFICATIONS: 'PUSH_NOTIFICATIONS',
	GIFT_CARD_RELOAD: 'GIFT_CARD_RELOAD',
	ORDERING: 'ORDERING',
	SHARE_URL: 'SHARE_URL',
} as const;
export type TFeatureFlag = typeof FeatureFlag[keyof typeof FeatureFlag];

export interface IFeatureFlag {
	name: TFeatureFlag;
	enabled: boolean;
}
